import isEmpty from 'lodash/isEmpty';

import { actionTypeRegExp as asynActionRegExp } from 'src/core/redux/reducers/asyncReducer';
import { status as statusConstants } from 'src/constants';

// import actions like this to avoid circular dependency
import {
  addManyNotifications,
  addOneNotification
} from 'src/core/redux/actions';

export default ({ dispatch }) => (next) => (action) => {
  const { type, notificationData } = action;

  const matchResult = type.match(asynActionRegExp);

  if (!matchResult) {
    return next(action);
  }

  const [, , , , status] = matchResult;

  if (
    [statusConstants.SUCCESS, statusConstants.ERROR].includes(status) &&
    !isEmpty(notificationData)
  ) {
    dispatch(
      Array.isArray(notificationData) ? addManyNotifications(notificationData) :
        addOneNotification(notificationData)
    );
  }

  return next(action);
};
